export const stripMarkdown = (text?: string | null) => {
    if (!text) {
        return undefined
    }
    return text
        .replace(/!\[.*?\]\(.*?\)/g, '') // images
        .replace(/\[([^\]]+)\]\(.*?\)/g, '$1') // links
        .replace(/`{1,3}[^`]*`{1,3}/g, '') // inline code / code blocks
        .replace(/#{1,6}\s/g, '') // headings
        .replace(/(\*{1,3}|_{1,3})(.*?)\1/g, '$2') // bold / italic
        .replace(/~~(.*?)~~/g, '$1') // strikethrough
        .replace(/^\s*[-*+>]\s+/gm, '') // lists and blockquotes
        .replace(/\n+/g, ' ') // newlines
        .trim()
}
